import Color from 'color';
import { PALETTE_COLOURS } from '@/store/types/getters';

export function generatePalette(baseColour = '#3771D0', darkMode = false) {
  const base = Color(baseColour).hsl();
  const hue = Math.round(base.color[0]);

  if (!darkMode) {
    // Light mode
    return [
      Color([hue, 100, 95], 'hsl').hex(),
      Color([hue, 63, 78], 'hsl').hex(),
      Color([hue, 73, 63], 'hsl').hex(),
      Color([hue, 100, 60], 'hsl').hex(),
      baseColour,
      Color([hue, 82, 41], 'hsl').hex(),
      Color([hue, 82, 33], 'hsl').hex(),
      Color([hue, 43, 21], 'hsl').hex(),
    ];
  }

  // Dark mode
  return [
    Color([hue, 43, 21], 'hsl').hex(),
    Color([hue, 82, 33], 'hsl').hex(),
    baseColour,
    Color([hue, 82, 41], 'hsl').hex(),
    Color([hue, 100, 60], 'hsl').hex(),
    Color([hue, 73, 63], 'hsl').hex(),
    Color([hue, 63, 78], 'hsl').hex(),
    Color([hue, 100, 95], 'hsl').hex(),
  ];
}

const successPalette = [
  '#EBF7EF',
  '#A1E6B8',
  '#3FB061',
  '#388C51',
  '#1F4D2C',
];
const warningPalette = [
  '#FFF7E6',
  '#F2D491',
  '#F5C256',
  '#B36A36',
  '#66421F',
];
const errorPalette = [
  '#FFEDED',
  '#F2AAAA',
  '#F14242',
  '#990F0F',
  '#662424',
];

const modes = {
  light: {
    white: '#ffffff',
    dark: '#2C384F',
    neutral: [
      '#FAFAFC',
      '#F5F6FA',
      '#EDF0FA',
      '#DDE3EB',
      '#BFCBD9',
      '#8594A6',
      '#566782',
      '#2C3A4F',
    ],
    successPalette,
    warningPalette,
    errorPalette,
  },
  dark: {
    white: '#1B1F28',
    dark: '#D3DCE6',
    neutral: [
      '#1F2733',
      '#252C37',
      '#323C4E',
      '#48556B',
      '#52617A',
      '#7587A3',
      '#96A2B3',
      '#D3DCE6',
    ],
    successPalette: [].concat(successPalette).reverse(),
    warningPalette: [].concat(warningPalette).reverse(),
    errorPalette: [].concat(errorPalette).reverse(),
  },
};

const getters = {
  [PALETTE_COLOURS](_, __, rootState) {
    const mode = rootState.persistence.uiDark
      ? modes.dark
      : modes.light;
    const branding = rootState.settings.colours;

    const base = { ...branding, ...mode };

    base.primary = rootState.settings.brandColour || '#3771D0';
    base.primaryPalette = generatePalette(base.primary, rootState.persistence.uiDark);

    return base;
  },
};

export default {
  namespaced: true,
  getters,
};
